import React from "react";

import {CircularProgress, Modal, ModalClose, ModalDialog} from "@mui/joy";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Typography from "@mui/joy/Typography";
import IconButton from "@mui/joy/IconButton";


class CommonActionModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false,
            ready: false,
            key: crypto.randomUUID(),
        };
    }

    async setModalOpenTrue(){
        let addState = {};
        if (this.beforeModalOpen) {
            addState = await this.beforeModalOpen();
        }
        addState.modalOpen = true
        this.setState(
            addState
        );
    }

    async setModalOpenFalse() {
        if (this.beforeModalClose){
            await this.beforeModalClose()
        }
        this.setState(
            {
                modalOpen: false,
                key: crypto.randomUUID(),
            }
        );
    }

    render() {
        if (!this.state.ready) {
            return (
                <CircularProgress/>
            )
        }
        if (this.state.permission !== undefined && !this.state.permission){
            return(
                <>
                    {
                        this.state.deniedPermissionComponent?
                            this.state.deniedPermissionComponent:
                            null
                    }
                </>
            )
        }

        return (
            <Box
                sx={
                    this.props.overlay?{
                        display: 'block',
                        width: '100%',
                        height: '100%',
                        cursor: 'pointer',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        borderRadius: 'md',
                        p: '0!important',
                        m: '0!important',
                    }:
                    {
                        p: this.state.buttonIconOnly || this.state.button?.iconOnly?'0!important':null,
                        m: this.state.buttonIconOnly || this.state.button?.iconOnly?'0!important':null,
                    }
                }
            >
                {
                    this.props.overlay?
                        <Box
                             sx={{
                                 "&:hover": {
                                     backgroundColor: localStorage.getItem("joy-mode") === 'dark'?'rgba(255,255,255,0.05)':'rgba(0,0,0,0.05)'
                                 },
                                 borderRadius: 'sm',
                                 width: '100%',
                                 height: '100%',
                            }}
                            onClick={this.setModalOpenTrue.bind(this)}
                        >
                        </Box>:
                        this.state.buttonLabel || this.state.button?.label?
                            <Button
                                size={'sm'}
                                color={this.state.buttonColor || this.state.button?.color}
                                sx={!this.state.flat?{mt: 1, mb: 1, mr: 1}:null}
                                onClick={this.setModalOpenTrue.bind(this)}
                                startDecorator={
                                    this.state.buttonIcon?
                                        <this.state.buttonIcon fontSize={'small'}/>:
                                        this.state.button?.icon?<this.state.button.icon fontSize={'small'}/>:
                                            null
                                }
                                variant={this.state.buttonVariant || this.state.button?.variant?this.state.buttonVariant || this.state.button?.variant:'soft'}
                            >
                                {this.state.buttonLabel || this.state.button?.label}
                            </Button>:
                            this.state.buttonIconOnly || this.state.button?.iconOnly?
                                this.state.buttonIcon?
                                    <IconButton
                                        size={'sm'}
                                        onClick={this.setModalOpenTrue.bind(this)}
                                        sx={{
                                            mt: 0,
                                            mb: 0,
                                            mr: 0,
                                            minHeight: '16px',
                                            minWidth: '16px',
                                        }}
                                    >
                                        <this.state.buttonIcon
                                            fontSize={'small'}
                                            sx={{
                                                fontSize: '16px',
                                            }}
                                            onClick={this.setModalOpenTrue.bind(this)}
                                        />
                                    </IconButton>:

                                    this.state.button?.icon?
                                        <IconButton
                                            size={'sm'}
                                            onClick={this.setModalOpenTrue.bind(this)}
                                            sx={{
                                                mt: 0,
                                                mb: 0,
                                                mr: 0,
                                                minHeight: '16px',
                                                minWidth: '16px',
                                            }}
                                        >
                                            <this.state.button.icon
                                                sx={{
                                                    fontSize: '16px',
                                                }}
                                            />
                                        </IconButton>:
                                        null
                                :
                                <IconButton
                                    size={'sm'}
                                    color={this.state.buttonColor || this.state.button?.color}
                                    sx={!this.state.flat?{mt: 1, mb: 1, mr: 1}:null}
                                    onClick={this.setModalOpenTrue.bind(this)}
                                >
                                    {
                                        this.state.buttonIcon?
                                            <this.state.buttonIcon fontSize={'small'}/>:
                                            this.state.button?.icon?<this.state.button.icon fontSize={'small'}/>:
                                                null
                                    }
                                </IconButton>
                }
                {
                    this.state.extraButtons ?
                        this.state.extraButtons.map(each => (
                            <Button
                                size={'sm'}
                                color={each.color}
                                variant={each.variant?each.variant:'soft'}
                                sx={{mt: 1, mb: 1, mr: 1}}
                                onClick={each.onClick}
                                startDecorator={each.icon ? <each.icon fontSize={'small'}/> : null}
                            >
                                {each.label}
                            </Button>
                        )):
                        null
                }
                {
                    this.state.modalOpen?
                        <Modal
                            open={this.state.modalOpen}
                        >
                            <ModalDialog
                                layout={'center'}
                                size={this.state.size || 'sm'}
                            >
                                <ModalClose
                                    onClick={this.setModalOpenFalse.bind(this)}
                                />
                                <Box
                                    sx={{
                                        overflowY: 'scroll',
                                        width: this.state.width?this.state.width:null,
                                        height: this.state.height?this.state.height:null,
                                        pr: 2
                                    }}
                                >
                                    <Typography
                                        level='h3'
                                        sx={{
                                            'mb': 3,
                                        }}
                                        startDecorator={this.state.modalIcon?<this.state.modalIcon fontSize={'small'}/>:null}
                                    >
                                         {this.state.modalLabel}
                                    </Typography>
                                    <this.state.mainComponent
                                        key={this.state.key}
                                        {...this.state.mainComponentProps}
                                    />
                                </Box>
                            </ModalDialog>
                        </Modal>:
                        null
                }
            </Box>
        )
    }
}

export default CommonActionModal
